import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,HttpResponse,HttpErrorResponse } from "@angular/common/http";
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable,of as observableOf, throwError } from "rxjs";
import { Tenant } from 'src/app/models/tenant.model';
import { environment } from 'src/environments/environment';
import { Feature } from 'src/app/models/feature.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private tenantData$ = new BehaviorSubject<Tenant | null>(null);
  valueee: boolean = false;

  private featureData$ = new BehaviorSubject<Feature[] | null>(null);
  private subscriptionJSON = 'assets/data/subscription.json';

  constructor(private http: HttpClient) {}
  loadSubscription(tenant: string): void {// called from appmodule.ts => initSubscription()
    //this.http.get<Feature[]>(this.subscriptionJSON).subscribe(data => this.featureData$.next(data));
    this.http.get<Feature[]>(environment.companyBase+'/subscription/feaures/'+tenant)
      .subscribe(data => this.featureData$.next(data));
  }

  getSchoolSubscription(): Observable<Feature[] | null> {
    return this.featureData$.asObservable();
  }

  getSchoolNUserSubscription(tenant: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/subscription/feaures/'+tenant);
  }
  
  hasFeature(featureVal: string): Observable<boolean> {
    console.log('--------------hasFeature for:::',featureVal);
    let isEnabled = false;
    return this.featureData$.pipe(
      //map(data => !!data?.subscriptionDetail.featureList.includes(feature))
      map(response => {
        //console.log('--------Feature Array----',JSON.stringify(response));
        let featureMatched =response?.find(feature => feature.name === featureVal);
        if(featureMatched){
            isEnabled = !!featureMatched.enabled;
        }
        console.log('>>>>>>>>isEnabled for feature:',isEnabled)
        return isEnabled;
      })
    );
  }
  /*hasFeature1(featureVal: string): Observable<boolean> {
    console.log('--------------hasFeature1-----------------');
    let value = false;
    return this.tenantData$.pipe(
      //map(data => !!data?.subscriptionDetail.featureList.includes(feature))
      map(response => {
        //const featureList = response?.subscriptionDetail.featureList ?? [];
        console.log('--------------returning-----------------',JSON.stringify(response));// response object is Tenant
        this.valueee =!response?.active;
        //this.valueee = !!response?.subscriptionDetail.featureList.some(feature => feature.name === featureVal && feature.enabled);
        console.log('>>>>>>>>this.valueee:',this.valueee)
        return this.valueee;
      })
    );
  }*/
}